import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import api from '../../api/endpoints';
import { handleErrors, fetch } from '../../api';

function* acceptInvitationSignUp({ payload: { values, onSuccess, handledErrors } }) {

  try {
    const { data } = yield call(fetch, { api: api.accept_invitation.sign_up, data: values });

    onSuccess();
    yield put(actions.acceptInvitationSignUpDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.acceptInvitationSignUpFailed,
      handledErrors,
      endpoint: api.accept_invitation.sign_up.url
    });
  }
}

export const acceptInvitationSignUpSaga = takeEvery(types.ACCEPT_INVITATION_SIGN_UP_REQUEST, acceptInvitationSignUp);